import React from "react";
import {
	Container,
	Header,
	Title,
	BadgeSoon,
	MetaText,
	Description,
	EarlyAccessButton,
} from "./styles";
import { useTodayAgendaViewModel } from "./useTodayAgendaViewModel";
import { ReactComponent as CalendarIcon } from "../../../../assets/kinologyIcons/svg/Icon-calendar.svg";
import { ReactComponent as ArrowRightIcon } from "../../../../assets/kinologyIcons/svg/arrow-right.svg";

const TodayAgenda: React.FC = () => {
	const { isRequested, handleRequestAgendaAccess } = useTodayAgendaViewModel();

	return (
		<Container aria-labelledby="today-agenda-title">
			<Header>
				<Title id="today-agenda-title">
					<CalendarIcon />
					Agenda de hoje
				</Title>
				<BadgeSoon>Em Breve</BadgeSoon>
			</Header>
			<MetaText>0 atendimentos • 0 avaliadores</MetaText>
			<Description>Veja todos os seus atendimentos por aqui</Description>
			<EarlyAccessButton
				onClick={handleRequestAgendaAccess}
				isRequested={isRequested}
				type="button"
				aria-label={
					isRequested
						? "Obrigada por demonstrar interesse!"
						: "Clique aqui para ter acesso antecipado"
				}
			>
				{isRequested ? (
					"Obrigada por demonstrar interesse!"
				) : (
					<>
						Clique aqui para ter acesso antecipado
						<ArrowRightIcon width="12px" height="12px" />
					</>
				)}
			</EarlyAccessButton>
		</Container>
	);
};

export default TodayAgenda;
